var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgClock(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 29,
    viewBox: "0 0 28 29",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.01 2.04004C20.93 2.04004 26.53 7.64003 26.53 14.56C26.53 21.48 20.93 27.08 14.01 27.08C7.09001 27.08 1.48999 21.48 1.48999 14.56C1.48999 7.64003 7.09001 2.04004 14.01 2.04004ZM14.01 0.790039C6.41001 0.790039 0.23999 6.96003 0.23999 14.56C0.23999 22.16 6.41001 28.33 14.01 28.33C21.61 28.33 27.78 22.16 27.78 14.56C27.78 6.96003 21.61 0.790039 14.01 0.790039Z",
    fill: "currentColor"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.0101 4.54004C13.8401 4.54004 13.6801 4.61003 13.5701 4.72003C13.4501 4.84003 13.3901 5.00003 13.3901 5.16003V14.29L8.57013 19.11C8.45013 19.23 8.39014 19.39 8.39014 19.55C8.39014 19.72 8.46013 19.8801 8.57013 19.9901C8.68013 20.1001 8.85013 20.17 9.01013 20.17C9.17013 20.17 9.34013 20.1001 9.45013 19.9901L14.4601 14.98C14.5801 14.86 14.6401 14.7 14.6401 14.54V5.15002C14.6401 4.98002 14.5701 4.82005 14.4601 4.71005C14.3301 4.61005 14.1701 4.54004 14.0101 4.54004Z",
    fill: "currentColor"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgClock);
export default __webpack_public_path__ + "static/media/clock.2c53e214.svg";
export { ForwardRef as ReactComponent };